<script lang="ts" setup>
  import { type FunctionalComponent, toRefs } from 'vue'

  import * as IconsImport from '@heroicons/vue/24/solid'
  import { pascalCase } from 'change-case'

  interface Props {
    icon?: string
    position?: 'start' | 'end'
    target?: '_blank' | '_parent' | '_self' | '_top' | string
  }

  const props = defineProps<Props>()
  const { icon, position } = toRefs(props)

  const Icons: Record<string, FunctionalComponent> = IconsImport
</script>
<template>
  <a
    :class="icon ? 'inline-flex items-center gap-x-1 leading-normal' : ''"
    :target="target"
    class="text-blue-700 font-semibold cursor-pointer">
    <component
      :is="Icons[`${pascalCase(icon)}Icon`]"
      v-if="icon && position !== 'end'"
      :class="'h-4 w-4'"
      aria-hidden="true" />
    <slot />
    <component
      :is="Icons[`${pascalCase(icon)}Icon`]"
      v-if="icon && position === 'end'"
      :class="'h-4 w-4'"
      aria-hidden="true" />
  </a>
</template>
